import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Adlog.css';
import config from '../../config/config';

const Adminlogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // 👇 Redirect if already logged in
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      navigate('/admin/0083/home');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    try {
      const response = await axios.post(`${config.apiBaseUrl}/api/admin/login`, {
        email,
        password,
      });

      if (response.data.message) {
        setSuccessMsg(response.data.message);
        localStorage.setItem('adminName', response.data.fullname);
        localStorage.setItem('adminToken', response.data.token);

        setTimeout(() => {
          navigate('/admin/0083/home');
        }, 1000);
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg('Something went wrong. Try again.');
      }
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-box">
        <h2 className="admin-login-title">ADMIN Login</h2>

        {errorMsg && <div className="error-message">{errorMsg}</div>}
        {successMsg && <div className="success-message">{successMsg}</div>}

        <form className="admin-login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="admin-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <label>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}  // <-- toggle type
              className="admin-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '35px',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.2rem',
                userSelect: 'none',
              }}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>

          <div className="forgot-password">
            <button 
              type="button" 
              className="link-button"
              onClick={() => navigate('/admin/0083/forgot-password')}
            >
              Forgot Password ??
            </button>
          </div>

          <button type="submit" className="admin-login-button">Login</button>

          <div className="register-link">
            Don't have account ?? 
            <button 
              type="button" 
              className="link-button"
              onClick={() => navigate('/0083')}
            >
              Register
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Adminlogin;
